import type { LocaleManifest } from '@packages/utils/i18n'

/**
 * Lazy locale manifest for the ai package. See
 * `src/packages/utils/i18n.ts` for the pattern.
 */
export const aiLocaleManifest: LocaleManifest = {
  namespace: 'ai',
  loaders: {
    ar: () => import('./ar.json'),
    de: () => import('./de.json'),
    fr: () => import('./fr.json'),
    pl: () => import('./pl.json'),
    uk: () => import('./uk.json')
  }
}
